import React, {useState} from 'react';
import {toast} from 'react-toastify';
import api from '../../../../api/axios';
import BaseModal from '../../../utils/BaseModal';
import {BuyOrder} from '../../profile/buyorder/UserBuyOrder';

type Props = {
  open: boolean;
  onClose: () => void;
  order: BuyOrder | null;
  onDeleted: () => void;
};

const SystemBuyOrderDeleteModal: React.FC<Props> = ({ open, onClose, order, onDeleted }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!order) return;
    setLoading(true);

    try {
      await toast.promise(
          api.delete(`/system/buy-orders/${order.id}`),
          {
            pending: "Deleting buy order...",
            success: "Buy order deleted",
            error: "Delete failed",
          }
      );
      onDeleted();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
      <BaseModal
          open={open}
          title="Delete Buy Order"
          onAbort={onClose}
          abortText="abbort"
          onSubmit={handleDelete}
          submitText="Delete"
          submitColor="error"
          submitDisabled={loading}
          abortDisabled={loading}
          maxWidth="xs"
      >
        <div className="text-neutral-300">
          Are you sure you want to delete the buy order for <br />
          <span className="font-bold text-white text-lg">
          {order?.itemName || 'this item'}
        </span>?
        </div>
      </BaseModal>
  );
};

export default SystemBuyOrderDeleteModal;